import { useEffect, useState } from "react";
// Data
import webinarData from "@/i18n/json/webinars/data.json";
// Interface
import { IWebinarContent } from "./interfaces";
// Style
import {
  wrapper,
  contentContainer,
  image,
  content,
  title as titleClasses,
  subtext,
  text,
} from "./styles/webinars-content";
import { useTranslation } from "react-i18next";
import PopupVideo from "../popup-video";
import { getCookie } from "@/lib/cookies";

const ContentWebinar: React.FC<IWebinarContent> = (props) => {
  const [hasConsentForYoutubeVideo, setHasConsentForYoutubeVideo] =
    useState(false);
  useEffect(() => {
    const consentCookie = getCookie("CookieConsent");
    const hasMarketingConsent = consentCookie.includes("marketing:true");
    const hasStatisticsConsent = consentCookie.includes("statistics:true");
    setHasConsentForYoutubeVideo(hasMarketingConsent && hasStatisticsConsent);
  });

  const { thumbnail, seo, title, index, video, showHandler } = props;
  const { t } = useTranslation();

  return (
    <div key={index} className={wrapper}>
      <div className={contentContainer}>
        <div
          className={image}
          onClick={() => {
            if (hasConsentForYoutubeVideo) {
              showHandler && showHandler(video.youtubeId);
            } else {
              window.open(
                `https://www.youtube.com/watch?v=${video.youtubeId}`,
                "_blank"
              );
            }
          }}
        >
          <img
            srcSet={`
                        ${thumbnail}small.webp 420w,
                        ${thumbnail}small.jpg 420w,
                        ${thumbnail}medium.webp 733w,
                        ${thumbnail}medium.jpg 733w,
                        ${thumbnail}large.webp 1465w,
                        ${thumbnail}large.jpg 1465w,
					`}
            sizes="(max-width:736px) 420px, (max-width:1280px) 800px, 1500px"
            src={`${thumbnail}small.jpg`}
            alt={seo.alt}
            title={seo.title}
          />
        </div>

        {/* webinar content section */}
        <div className={content}>
          <div className={titleClasses}>
            {t(`webinars.webinar-content.webinar-videos.${index}.title`)}
          </div>
          <div className={subtext}>
            {t(`webinars.webinar-content.webinar-videos.${index}.host`)}
          </div>
          <div className={subtext}>
            {t(`webinars.webinar-content.webinar-videos.${index}.duration`)}
          </div>
          <div className={text}>
            {t(`webinars.webinar-content.webinar-videos.${index}.description`)}
          </div>
        </div>
      </div>
    </div>
  );
};

const WebinarsContent: React.FC = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoId, setVideoId] = useState<string | null>(null);
  const showVideoHandler = (videoId: string) => {
    setVideoId(videoId);
    setShowVideo(true);
  };
  const closePopup = () => {
    setVideoId(null);
    setShowVideo(false);
  };
  return (
    <div>
      {showVideo && videoId != null && (
        <PopupVideo youtubeId={videoId} closeHandler={closePopup} />
      )}
      {Object.entries(webinarData["webinar-content"].webinarVideos)
        .sort((a, b) => {
          return a[0] > b[0] ? -1 : 1;
        })
        .map(([index, item]) => (
          <ContentWebinar
            showHandler={showVideoHandler}
            {...item}
            index={+index}
          />
        ))}
    </div>
  );
};

export default WebinarsContent;
